import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Image, Container, Form, Button } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../SignUp/onBoarding/abt-yourself.css";

import basicdetails from "../../../../../assets/images/basic-details.png";

import { API_URL } from "../../../../../api";
import { useCookies } from "../../../../../hooks/useCookies";
import Sidebar from "../../../../userflow/components/sidebar/sidebar";
import { useProfile } from "../../../../userflow/components/context/ProfileContext";
import * as userActions from "../../../../../actions/user";
import { showAlert } from "../../../../../utils/alertUtils";

export const WantGenderUpdate = () => {
  const { updateProfile } = useProfile();
  const { getCookie } = useCookies();
  const navigate = useNavigate();

  const [havegender, setHavegender] = useState(0);
  const [wantGender, setWantGender] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [femaleActive, setFemaleActive] = useState(false);
  const [maleActive, setMaleActive] = useState(false);
  const [nonBinaryActive, setNonBinaryActive] = useState(false);
  const [femaleSvgColor, setFemaleSvgColor] = useState("#AAAAAA");
  const [maleSvgColor, setMaleSvgColor] = useState("#AAAAAA");
  const [nonBinarySvgColor, setNonBinarySvgColor] = useState("#AAAAAA");
  const approvalstatus = getCookie("approval");

  const handleFemaleButtonClick = () => {
    setFemaleActive(true);
    setMaleActive(false);
    setNonBinaryActive(false);
    setFemaleSvgColor("#8457A8");
    setMaleSvgColor("#AAAAAA");
    setNonBinarySvgColor("#AAAAAA");
    setHavegender(2);
  };

  const handleMaleButtonClick = () => {
    setFemaleActive(false);
    setMaleActive(true);
    setNonBinaryActive(false);
    setFemaleSvgColor("#AAAAAA");
    setMaleSvgColor("#8457A8");
    setNonBinarySvgColor("#AAAAAA");
    setHavegender(1);
  };

  const handleNonBinaryButtonClick = () => {
    setFemaleActive(false);
    setMaleActive(false);
    setNonBinaryActive(true);
    setFemaleSvgColor("#AAAAAA");
    setMaleSvgColor("#AAAAAA");
    setNonBinarySvgColor("#8457A8");
    setHavegender(3);
  };

  const [selectedOption, setSelectedOption] = useState(null);

  const handlePrefer = option => {
    setSelectedOption(option);
    const wantGender = option === "female" ? 2 : option === "male" ? 1 : 3;
    setWantGender(wantGender);
  };

  const handleSubmit = async event => {
    event.preventDefault();
    try {
      // Update the want_gender
      const response = await fetch(`${API_URL}customer/update/wantgender`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
        body: JSON.stringify({
          want_gender: wantGender,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        // If the want_gender update is successful, update the preference
        const preferenceResponse = await fetch(
          `${API_URL}customer/user/preferences/save/gender_id`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getCookie("token")}`,
            },
            body: JSON.stringify({ value: wantGender }),
          }
        );

        const preferenceResult = await preferenceResponse.json();

        if (preferenceResponse.ok) {
          await updateProfile("update");
          if (approvalstatus === "PENDING") {
            showAlert("Success", "Approval request sent!", () =>
              navigate("/user/home")
            );
          } else {
            showAlert("Success", "Successfully updated", () =>
              navigate("/updateprofile")
            );
          }
        } else {
          setErrorMessage(
            preferenceResult.errors
              ? preferenceResult.errors.map(error => error.msg).join(", ")
              : "Error updating preference"
          );
        }
      } else {
        setErrorMessage(
          result.errors
            ? result.errors.map(error => error.msg).join(", ")
            : "Error updating profile"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Error updating profile");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await userActions.getUserGender();
        const result = await response;
        if (result) {
          const { gender, want_gender } = result;
          setHavegender(gender);
          setWantGender(want_gender);

          if (gender === 1) {
            handleMaleButtonClick();
          } else if (gender === 2) {
            handleFemaleButtonClick();
          } else if (gender === 3) {
            handleNonBinaryButtonClick();
          }

          if (want_gender === 1) {
            setSelectedOption("male");
          } else if (want_gender === 2) {
            setSelectedOption("female");
          } else if (want_gender === 3) {
            setSelectedOption("all");
          }
        } else {
          console.error("Error fetching user data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
          scrollbarWidth: "none",
          padding: "2rem",
        }}
      >
        <div className="birthday-container" style={{ overflow: "hidden" }}>
          <Container className="birthday-main">
            <Container className="birthday-content" style={{ width: "100%" }}>
              <Container className="birthday-text">
                <Image
                  className="about-yourself-icon"
                  src={basicdetails}
                ></Image>
                <p>Who do you want to date? *</p>
              </Container>
              <Container className="birthday-details">
                <Form className="birthday-form" onSubmit={handleSubmit}>
                  <Form.Group controlId="formgender" className="birthday-group">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "space-around",
                      }}
                    >
                      <Button
                        className="prefer-whome"
                        onClick={() => handlePrefer("female")}
                        style={{
                          background:
                            selectedOption === "female"
                              ? "linear-gradient(90deg, #9663BF 0%, #4B164C 100%)"
                              : "transparent",
                          fontFamily: '"Inter"',
                          fontSize: "16px",
                          fontWeight: "500",
                          color:
                            selectedOption === "female" ? "white" : "#6C6C6C",
                          lineHeight: "24px",
                          letterSpacing: "0.04em",
                          border:
                            selectedOption === "female"
                              ? "none"
                              : "1px solid #6C6C6C ",
                          marginRight: "5px",
                          borderRadius: "24px",
                        }}
                      >
                        Women
                      </Button>
                      <Button
                        className="prefer-whome"
                        onClick={() => handlePrefer("male")}
                        style={{
                          background:
                            selectedOption === "male"
                              ? "linear-gradient(90deg, #9663BF 0%, #4B164C 100%)"
                              : "transparent",
                          fontFamily: '"Inter"',
                          fontSize: "16px",
                          fontWeight: "500",
                          color:
                            selectedOption === "male" ? "white" : "#6C6C6C",
                          lineHeight: "24px",
                          letterSpacing: "0.04em",
                          border:
                            selectedOption === "male"
                              ? "none"
                              : "1px solid #6C6C6C ",
                          marginRight: "5px",
                          borderRadius: "24px",
                        }}
                      >
                        Men
                      </Button>
                      <Button
                        className="prefer-whome"
                        onClick={() => handlePrefer("all")}
                        style={{
                          background:
                            selectedOption === "all"
                              ? "linear-gradient(90deg, #9663BF 0%, #4B164C 100%)"
                              : "transparent",
                          fontFamily: '"Inter"',
                          fontSize: "16px",
                          fontWeight: "500",
                          color: selectedOption === "all" ? "white" : "#6C6C6C",
                          lineHeight: "24px",
                          letterSpacing: "0.04em",
                          border:
                            selectedOption === "all"
                              ? "none"
                              : "1px solid #6C6C6C ",
                          borderRadius: "24px",
                        }}
                      >
                        All
                      </Button>
                    </div>
                    {errorMessage && (
                      <Form.Text className="text-danger error-message">
                        {errorMessage}
                      </Form.Text>
                    )}
                  </Form.Group>
                  {/* 
                            <Button variant="primary" type="submit" className='birthday-nxt-btn'>
                                Next
                            </Button> */}
                  <div
                    className="d-flex justify-content-center"
                    style={{
                      position: "fixed",
                      bottom: "30px",
                      width: "100%",
                      gap: "30px",
                    }}
                  >
                    <button
                      className="global-cancel-button"
                      onClick={() => navigate("/updateprofile")}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="global-save-button">
                      Save
                    </button>
                  </div>
                </Form>
              </Container>
            </Container>
          </Container>
        </div>
      </div>
    </Sidebar>
  );
};
